module.exports = __webpack_public_path__ + "static/media/portfolio-profile.f3739aa2.JPG";